import { loadScript } from '@/utils/loadScript';
export const toc = {
  data: () => {
    return {
      tocModal: false,
      form: {
        idFront: {
          value: '',
          error: '',
          rules: [],
        },
        idBack: {
          value: '',
          error: '',
          rules: [],
        },
        idLiveness: {
          value: '',
          error: '',
          rules: [],
        },
        photoFront: {
          value: '',
          error: '',
          rules: [],
        },
        photoBack: {
          value: '',
          error: '',
          rules: [],
        },
        selfie: {
          value: '',
          error: '',
          rules: [],
        },
      },
      livenessErrors: [
        {
          id: 402,
          name: 'Timeout',
          message: 'Se superó el tiempo del proceso',
          critical: false,
        },
        {
          id: 403,
          name: 'Cancelado',
          message: 'Fue cancelado por el usuario',
          critical: false,
        },
        {
          id: 404,
          name: 'Internet',
          message: 'No hay conexión a internet',
          critical: false,
        },
        {
          id: 405,
          name: 'Sesión',
          message: 'Session-id inválido',
          critical: false,
        },
        {
          id: 406,
          name: 'Endpoint',
          message: 'No se ha podido resolver el endpoint entregado',
          critical: true,
        },
        {
          id: 407,
          name: 'Cámara',
          message: 'Cámara no disponible',
          critical: false,
        },
        {
          id: 411,
          name: 'Parámetros',
          message: 'Falta session-id',
          critical: true,
        },
        {
          id: 430,
          name: 'Inválido',
          message: 'Imágen del rostro no pasa validaciones mínimas',
          critical: true,
        },
        {
          id: 450,
          name: 'Error',
          message: 'Error no controlado',
          critical: true,
        },
      ],
      autocapturaErrors: [
        {
          id: 401,
          name: '',
          message: 'Envío de datos fallido',
          critical: true,
        },
        {
          id: 402,
          name: '',
          message: 'Tiempo límite excedido',
          critical: false,
        },
        {
          id: 403,
          name: '',
          message: 'Cancelado por el usuario',
          critical: false,
        },
        {
          id: 404,
          name: '',
          message: 'Sin internet',
          critical: false,
        },
        {
          id: 405,
          name: '',
          message: 'Sesión expirada',
          critical: false,
        },
        {
          id: 406,
          name: '',
          message: 'No hay conexión con el servidor',
          critical: true,
        },
        {
          id: 411,
          name: 'Parámetros faltantes',
          message: 'Falta session_id',
          critical: true,
        },
        {
          id: 412,
          name: '',
          message: 'Falta el tipo de documento',
          critical: true,
        },
        {
          id: 413,
          name: '',
          message: 'Falta el lado del documento',
          critical: true,
        },
        {
          id: 421,
          name: 'Error en contenido de parámetros',
          message: 'session_id no válido',
          critical: false,
        },
        {
          id: 422,
          name: '',
          message: 'Tipo de documento no soportado',
          critical: true,
        },
        {
          id: 430,
          name: '',
          message: 'La cédula no pudo ser validada',
          critical: true,
        },
        {
          id: 431,
          name: '',
          message: 'session_id ya utilizado',
          critical: false,
        },
        {
          id: 450,
          name: '',
          message: 'Error de plugin',
          critical: false,
        },
      ],
      documentTypeId: 'CHL2',
      idioma: 'es',
    };
  },
  methods: {
    goesTo(side) {
      this.$store
        .dispatch('register/getTocSession')
        .then(response => {
          if (response.sessionId) {
            this.tocModal = true;
            if (side === 'liveness') {
              if (
                response.livenessUrl.search(this.TOC_SANDBOX_BASE_URL) === -1
              ) {
                loadScript(this.TOC_LIVENESS_PROD, 'tocliveness', () => {
                  this.callTocMethod(
                    response.sessionId,
                    side,
                    response.livenessUrl,
                  );
                });
              } else {
                loadScript(this.TOC_LIVENESS_SANDBOX, 'tocliveness', () => {
                  this.callTocMethod(
                    response.sessionId,
                    side,
                    response.livenessUrl,
                    true,
                  );
                });
              }
            } else {
              if (
                response.autoCaptureUrl.search(this.TOC_SANDBOX_BASE_URL) === -1
              ) {
                loadScript(this.TOC_AUTOCAPTURE_PROD, 'tocautocapture', () => {
                  this.callTocMethod(
                    response.sessionId,
                    side,
                    response.autoCaptureUrl,
                  );
                });
              } else {
                loadScript(
                  this.TOC_AUTOCAPTURE_SANDBOX,
                  'tocautocapture',
                  () => {
                    this.callTocMethod(
                      response.sessionId,
                      side,
                      response.autoCaptureUrl,
                      true,
                    );
                  },
                );
              }
            }
          } else {
            this.$toast.error('Ocurrió un error inesperado');
            if (side == 'liveness') {
              this.$router.push('/admin/sign-up/error-toc-liveness');
            } else {
              this.$router.push('/admin/sign-up/error-toc-autocaptura');
            }
          }
        })
        .catch(response => {
          console.log(response);
        });
    },
    callTocMethod(sessionId, side, url, sandboxMode = false) {
      let options = {
        locale: this.idioma,
        session_id: sessionId,
      };
      let method = side == 'liveness' ? 'TOCliveness' : 'TOCautocapture';
      if (method === 'TOCautocapture') {
        options.document_type = this.documentTypeId;
        options.document_side = side;
        options.failure = error => {
          console.log(error);
          this.tocModal = false;
          this.handleAutocapturaError(error);
        };
        if (!sandboxMode) {
          options.alt_server = this.TOC_AUTOCAPTURE_ALT_SERVER;
          options.url_lbac = url;
        }
      } else {
        options.failure = error => {
          console.log(error);
          this.tocModal = false;
          this.handleLivenessError(error);
        };
        if (!sandboxMode) {
          options.alt_server = this.TOC_LIVENESS_ALT_SERVER;
          options.url_lbliv = url;
        }
      }
      options.callback = (capturedToken, image) => {
        console.log(capturedToken, image);
        if (side === 'front') {
          this.form.idFront.value = capturedToken;
          this.form.photoFront.value = image;
        } else {
          if (side === 'back') {
            this.form.idBack.value = capturedToken;
            this.form.photoBack.value = image;
          } else {
            if (side === 'liveness') {
              this.form.idLiveness.value = capturedToken;
              this.form.selfie.value = image;
            }
          }
        }
        this.tocModal = false;
      };
      setTimeout(() => {
        window[method]('toc-container', options);
      }, 100);
    },
    handleAutocapturaError(error) {
      let errorObject = this.autocapturaErrors.find(
        element => element.id == error,
      );
      if (!errorObject) {
        this.$router.push('/admin/sign-up/error-toc-autocaptura');
      } else {
        if (errorObject.critical) {
          this.$router.push('/admin/sign-up/error-toc-autocaptura');
        } else {
          this.$toast.error(errorObject.message);
        }
      }
    },
    handleLivenessError(error) {
      let errorObject = this.livenessErrors.find(
        element => element.id == error,
      );
      if (!errorObject) {
        this.$router.push('/admin/sign-up/error-toc-liveness');
      } else {
        if (errorObject.critical) {
          this.$router.push('/admin/sign-up/error-toc-liveness');
        } else {
          this.$toast.error(errorObject.message);
        }
      }
    },
  },
  created() {
    this.TOC_SANDBOX_BASE_URL = 'sandbox-api.7oc.cl';
    this.TOC_AUTOCAPTURE_SANDBOX =
      'https://sandbox-web-plugins.s3.amazonaws.com/autocapture/autocapture.js';
    this.TOC_LIVENESS_SANDBOX =
      'https://sandbox-web-plugins.s3.amazonaws.com/liveness/js/liveness.js';
    this.TOC_AUTOCAPTURE_PROD =
      'https://prod-web-plugins.s3.amazonaws.com/autocapture/autocapture.js';
    this.TOC_LIVENESS_PROD =
      'https://prod-web-plugins.s3.amazonaws.com/liveness/js/liveness.js';
    this.TOC_AUTOCAPTURE_ALT_SERVER = 'https://prod-capture.tocws.com';
    this.TOC_LIVENESS_ALT_SERVER = 'https://prod-liveness.tocws.com';
  },
};
